import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { contactUsServices } from '../../../contactus/old_index';
import { MatSelectModule } from '@angular/material/select';
import { ResponsiveContactUsDialogComponent } from './responsive-contact-us-dialog.component';
import { MatInputModule } from '@angular/material/input';
import { MatDialogModule } from '@angular/material/dialog';
import { ResponsiveContactUsComponent } from './responsive-contact-us.component';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { SharedModule } from 'app/shared/shared.module';
import { MatButtonModule } from '@angular/material/button';
import { ResponsiveCommonModule } from '@feature/_app_modules/responsive-common/responsive-common.module';
import { ContactUsService } from './responsive-contact-us.service';
import { FuseAlertModule } from '@fuse/components/alert';

@NgModule({
    declarations: [
        ResponsiveContactUsComponent,
        ResponsiveContactUsDialogComponent
    ],
    imports     : [
        MatIconModule,
        MatDialogModule,
        ResponsiveCommonModule,
        MatButtonModule,
        MatSelectModule,
        MatInputModule,
        SharedModule,
        FuseAlertModule,
        MatAutocompleteModule
    ],
    providers:[
        ContactUsService
    ],
    exports     : [
        ResponsiveContactUsDialogComponent,
        ResponsiveContactUsComponent
    ]
})
export class ResponsiveContactUsModule
{
}
